module.exports = __webpack_public_path__ + "media/bootstrap-icons/diamond-fill-c1f50295.svg";